import { COMMUNITY_POST_CATEGORY_MAX_CHARS } from './community-post.policy';

export const COMMUNITY_POST_CATEGORY_SLUG_MAX = 80;
export const COMMUNITY_POST_CATEGORY_COLOR_PATTERN = /^#[0-9A-Fa-f]{6}$/;
export const COMMUNITY_POST_CATEGORY_ICON_MAX = 32;
export const COMMUNITY_POST_CATEGORIES_MAX = 5;

export function normalizeCommunityPostCategoryName(name?: string | null): string | null {
  const trimmed = name?.trim();
  if (!trimmed) return null;
  return trimmed.slice(0, COMMUNITY_POST_CATEGORY_MAX_CHARS);
}

export function normalizeCommunityPostCategoryColor(color?: string | null): string | null {
  const trimmed = color?.trim();
  if (!trimmed) return null;
  const normalized = trimmed.startsWith('#') ? trimmed : `#${trimmed}`;
  if (!COMMUNITY_POST_CATEGORY_COLOR_PATTERN.test(normalized)) return null;
  return normalized.toLowerCase();
}

export function normalizeCommunityPostCategoryIcon(icon?: string | null): string | null {
  const trimmed = icon?.trim();
  if (!trimmed) return null;
  return trimmed.slice(0, COMMUNITY_POST_CATEGORY_ICON_MAX);
}

export function normalizeCommunityPostCategories(
  categories?: string[] | null,
  primaryCategory?: string | null,
): string[] {
  const seen = new Set<string>();
  const normalized: string[] = [];

  for (const candidate of [...(categories ?? []), primaryCategory ?? '']) {
    const name = normalizeCommunityPostCategoryName(candidate);
    if (!name) continue;
    const key = name.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    normalized.push(name);
    if (normalized.length >= COMMUNITY_POST_CATEGORIES_MAX) break;
  }

  return normalized;
}

export function postMatchesCommunityCategoryFilter(
  filter: string,
  primaryCategory?: string | null,
  categories?: string[] | null,
): boolean {
  const normalizedFilter = normalizeCommunityPostCategoryName(filter);
  if (!normalizedFilter) return true;
  const filterKey = normalizedFilter.toLowerCase();
  const all = normalizeCommunityPostCategories(categories, primaryCategory);
  return all.some((name) => name.toLowerCase() === filterKey);
}

export function slugifyCommunityPostCategory(name: string): string {
  const slug = name
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, COMMUNITY_POST_CATEGORY_SLUG_MAX);
  return slug || 'tag';
}

export function buildCommunityPostCategorySlugCandidate(baseSlug: string, attempt: number): string {
  if (attempt <= 0) return baseSlug;
  const suffix = `-${attempt + 1}`;
  return `${baseSlug.slice(0, Math.max(1, COMMUNITY_POST_CATEGORY_SLUG_MAX - suffix.length))}${suffix}`;
}

export function resolveCommunityPostCategoryFilter(
  category?: string | null,
): string | null {
  return normalizeCommunityPostCategoryName(category);
}
